export function roundTo(
  value: number,
  roundToNumber: number,
  type: "round" | "floor" | "ceil" = "round",
) {
  const func = Math[type];
  return func(value / roundToNumber) * roundToNumber;
}
